import React, {Component} from 'react';
import axios from "axios";

import {LOCAL_STORAGE_NEWSLETTER_SIGNED_UP} from "../store/const";

export default class NewsletterSignupForm extends Component {

    constructor(props) {
        super(props);
        this.state = {
            emailSend: false,
            valid: false,
            email: "",
            name: ""
        };
    };

    inputChangedHandler(event, inputIdentifier) {
        const updatedState = {...this.state};

        updatedState[inputIdentifier] = event.target.value;

        const pattern = /[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*@(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?/;

        updatedState.valid = updatedState.name.trim() !== '' && pattern.test(updatedState.email);

        this.setState(updatedState);
    };

    signUpHandler = (event) => {
        event.preventDefault();

        if (!this.state.valid) {
            if (this.props.onInvalidForm) {
                this.props.onInvalidForm();
            }
            return;
        } else {
            if (this.props.onValidForm) {
                this.props.onValidForm();
            }
        }

        axios.post('/ajax/newsletter/signup', {
            name: this.state.name,
            email: this.state.email
        }).then((response) => {

            if (this.props.onSignUpSuccess) {
                this.props.onSignUpSuccess()
            }

            const updatedState = {
                email: '',
                name: ''
            };

            localStorage.setItem(LOCAL_STORAGE_NEWSLETTER_SIGNED_UP, true);

            this.setState(updatedState);

        }).catch((error) => {
            console.log(error);
        });
    };

    render() {
        return (
            <div>
                <form onSubmit={this.signUpHandler} noValidate>
                    <input className=""
                           name="name"
                           type="text"
                           id="share-mail"
                           placeholder="Fyll inn navnet ditt"
                           value={this.state.name}
                           onChange={(event) => this.inputChangedHandler(event, "name")}
                    />
                    <input className=""
                           name="email"
                           type="email"
                           id="share-mail"
                           placeholder="Fyll inn din e-postadresse"
                           value={this.state.email}
                           onChange={(event) => this.inputChangedHandler(event, "email")}
                    />

                    <button id="signup-newsletter-btn">Registrer deg</button>
                    {/*<button disabled={!this.state.valid} id="signup-newsletter-btn">Tilmeld</button>*/}
                </form>
            </div>
        );
    }
}


// WEBPACK FOOTER //
// ./src/components/NewsletterSignupForm.js